import {AfterViewInit, Component, ElementRef, inject, input, viewChild} from '@angular/core';
import Talk from 'talkjs';
import {firstValueFrom} from 'rxjs';
import {TokenFetcherControllerService} from '@frontend/shared-api';

@Component({
  selector: 'app-chat',
  imports: [],
  templateUrl: './chat.component.html',
})
export class ChatComponent implements AfterViewInit {
  readonly appId = input<string>();
  readonly conversationId = input<string>();
  readonly conversationSubject = input<string>();
  readonly currentUserId = input<string>();
  readonly currentUserName = input<string>();
  readonly currentUserRole = input<'customer' | 'provider'>();
  readonly containerId = input('talkjs-container');
  readonly chatContainer = viewChild.required<ElementRef<HTMLDivElement>>('chatContainer');

  private session: any;
  private conversationRef: any;
  private tokenFetcherService = inject(TokenFetcherControllerService);

  ngAfterViewInit(): void {
    // Add a small delay to ensure tab content is rendered
    setTimeout(() => {
      this.initializeChat();
    }, 100);
  }

  private async fetchNewToken(): Promise<string> {
    const response = await firstValueFrom(this.tokenFetcherService.fetchToken());
    return response.token;
  }

  private initializeChat(): void {
    if (
      !this.appId() ||
      !this.conversationId() ||
      !this.conversationSubject() ||
      !this.currentUserName() ||
      !this.currentUserId() ||
      !this.currentUserRole()
    ) {
      console.error(
        'App ID, Conversation ID, Subject, User Name, User ID and User Role must be set for the chat to work.',
      );
    }

    Talk.ready.then(async () => {
      this.session = new Talk.Session({
        appId: this.appId()!,
        userId: this.currentUserId(),
        tokenFetcher: () => this.fetchNewToken(),
      });

      this.conversationRef = this.session.conversation(this.conversationId());
      this.conversationRef.createIfNotExists({
        subject: this.conversationSubject(),
      });

      const chatbox = this.session.createChatbox();
      chatbox.select(this.conversationRef);
      let containerElement: HTMLElement | null = this.chatContainer()?.nativeElement;
      if (!containerElement) {
        containerElement = document.getElementById(this.containerId());
      }

      if (containerElement) {
        chatbox.mount(containerElement);
      } else {
        console.error(`TalkJS container element with ID '${this.containerId()}' not found`);
      }
    });
  }
}
